import type React from 'react';

import type { UserTier } from '@/utils/userTier';

import { Tier2CasesContainer } from './Tier2CasesContainer';

/**
 * Tier page registry for the cases list route.
 *
 * Maps a user tier to the cases list page component it should see. Tiers without an
 * entry (e.g. 'standard') fall back to the default CasesContainer in CasesRouter.
 *
 * To add a tier-specific cases page:
 * 1. Add the tier to `UserTier` and a rule in `@/utils/userTier`.
 * 2. Create the page component and register it here.
 */
const TIER_PAGES: Partial<Record<UserTier, React.FC>> = {
  tier2: Tier2CasesContainer,
};

/**
 * Get the cases list page component for a tier, or undefined to use the default.
 */
export function getCasesPageForTier(tier: UserTier): React.FC | undefined {
  return TIER_PAGES[tier];
}
